import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getOperationCode,
  getSubUniverseName,
  getUniverseName
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (state, action) => ({ // (state: State, action: UniverseClickAction)
  'Operation Code': getOperationCode(state),
  'Page Name': 'Salehome page',
  'Under Universe': getSubUniverseName(state),
  'Universe': getUniverseName(state),
  'Universe call price': action.payload.callPrice,
  'Universe min nights': action.payload.minNights,
  'Universe position': action.payload.position
})

const clickUniverseThumbnailEpic = (
  actions$,
  state$
) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.universes.UNIVERSE_CLICK),
  tap(action => {
    const eventName = 'Click Universe Thumbnail'

    track(eventName, mapStateToMPEvent(state$.value, action), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickUniverseThumbnailEpic
